// extracted by mini-css-extract-plugin
export default {"actionButton":"shop-item-actions__actionButton__BT1VT","quantityNeededWrapper":"shop-item-actions__quantityNeededWrapper__FRYxP"};